import fetch from '@/api/fetch.js'
import { reg } from './config'

const DOMAIN_NAME = `https://interaction-api.winbaoxian.${reg ? 'com' : 'cn'}`
const _fetch = (config = {}) => {
  return fetch({
    baseURL: DOMAIN_NAME,
    ...config,
  }).then(response => {
    const { data, success, code, info } = response.data;
    if (!success) {
      return Promise.reject(new Error(`${code}: ${info}`));
    }
    return data
  })
}

export function postInteractionDirectStartForClient(params) {
  return _fetch({
    url: '/interactionDirectCall/directStartForClient',
    method: 'POST',
    data: params
  })
}

export function getInteractionUserSig(uniqId) {
  return _fetch({
    url: `/interactionCommon/userSig/get/${uniqId}`
  })
}

/**
 * 判断入参的群ID是否有效 无效则新建群并返回 没有群ID则失败 请重试
 */
 export function verifyGroup(params) {
  return _fetch({
    url: '/interactionDirectCall/verifyGroup',
    method: 'POST',
    data: params
  })
}

export function getInteractionControl(params) {
  return _fetch({
    url: '/interactionCommon/getControl',
    method: 'POST',
    data: params
  })
}

export function endInteractionByClient (params) {
  return _fetch({
    url: '/interactionCommon/endInteractionByClient',
    method: 'POST',
    data: params
  })
}
